/**
 * VisitorsTab — placeholder renderer for the Visitors tab.
 *
 * Visitor-log projection isn't wired client-side yet. When it lands
 * (inbound visits via the village door, plus the home-zone log), the
 * dispatch will populate `state.lines` and this renderer will extend
 * accordingly.
 */

import * as Phaser from 'phaser';
import { renderEmptyStateTab } from './emptyStateRenderer';
import type { JournalTabState } from './journalDispatch';

export function renderVisitorsTab(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  state: JournalTabState,
): void {
  renderEmptyStateTab(scene, container, state);
}
